import React from 'react';
import { CarouselCard } from '../components/carousel/CarouselCard';
import { vol5Slides } from '../data/vol5Carousel';
export function Vol5Carousel() {
  return <main className="min-h-screen w-full bg-navy-deep py-12 font-sans text-white" data-id="element-353" data-mp="bu7gt9mh1eop">
      <header className="mx-auto max-w-6xl px-6" data-id="element-354" data-mp="6zbqcdwvuzdp">
        <h1 className="font-display text-2xl text-white" data-id="element-355" data-mp="302rwvqwedbt">
          Volume 5 · Shut Down the Inning — social carousel
        </h1>
        <p className="mt-1 text-sm text-white/60" data-id="element-356" data-mp="3u7fczluwjax0">
          5 cards · 4:5 · drawn at 540×675, export at 2× for 1080×1350
        </p>
      </header>

      <div className="mt-8 flex snap-x snap-mandatory gap-8 overflow-x-auto px-6 pb-6" data-id="element-357" data-mp="3k7eqjr1qkeol">
        {vol5Slides.map((slide, i) => <CarouselCard key={slide.imageLabel} slide={slide} index={i} total={vol5Slides.length} data-id="element-358" data-mp="3g74mijxi7ycd" data-mpi={i} />)}
      </div>
    </main>;
}